import { File, FileType, StorageProviderType } from '../types';

export function isFileVkVideo<D = Date>(file: File<D>): boolean {
  return (
    file &&
    file.type === FileType.Video &&
    file.provider === StorageProviderType.VK
  );
}
